<template>
  <div style="height:100%;padding:0 0 40px 0;">
    <div class="login-container note" :style="note">
      <!-- <el-carousel :interval="5000" arrow="always" class="login-container" >
      <el-carousel-item v-for="item in imgList" :key="item.id">
        <el-row>
          <el-col :span="24"><img ref="imgHeight" :src="item.idView" class="banner_img"/></el-col>
        </el-row>
      </el-carousel-item>
      </el-carousel>-->
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        autocomplete="on"
        label-position="left"
      >
        <div class="title-container">
          <h3 class="title">{{title}}</h3>
          <!-- <lang-select class="set-language" /> -->
        </div>

        <el-form-item prop="account_name">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            ref="account_name"
            v-model="loginForm.account_name"
            :placeholder="$t('login.username')"
            name="account_name"
            type="text"
            tabindex="1"
            autocomplete="on"
          />
        </el-form-item>

        <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
          <el-form-item prop="account_password">
            <span class="svg-container">
              <svg-icon icon-class="password" />
            </span>
            <el-input
              :key="passwordType"
              ref="account_password"
              v-model="loginForm.account_password"
              :type="passwordType"
              :placeholder="$t('login.password')"
              name="account_password"
              tabindex="2"
              autocomplete="on"
              @keyup.native="checkCapslock"
              @blur="capsTooltip = false"
              @keyup.enter.native="handleLogin"
            />
            <span class="show-pwd" @click="showPwd">
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>
        </el-tooltip>
        <el-form-item prop="account_name">
          <span class="svg-container">
            <svg-icon icon-class="peoples" />
          </span>
          <el-select style="width:90%" v-model="loginForm.account_type" value placeholder="请选择账号类别">
            <el-option
              v-for="item in account_type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button
          type="primary"
          style="width:100%;margin-bottom:30px;"
          @click.native.prevent="handleLogin"
        >{{ $t('login.logIn') }}</el-button>

        <div style="position:relative">
          <div class="tips">
            <!-- <span>{{ $t('login.username') }} : admin</span>
            <span>{{ $t('login.password') }} : {{ $t('login.any') }}</span>-->
          </div>
          <div class="tips">
            <!-- <span style="margin-right:18px;">
            {{ $t('login.username') }} : editor
          </span>
            <span>{{ $t('login.password') }} : {{ $t('login.any') }}</span>-->
          </div>
          <br />
          <!-- <el-button
          class="thirdparty-button"
          type="primary"
          @click="showDialog=true"
          >{{ $t('login.thirdparty') }}</el-button>-->
        </div>
      </el-form>

      <!-- <el-dialog :title="$t('login.thirdparty')" :visible.sync="showDialog">
      {{ $t('login.thirdpartyTips') }}
      <br />
      <br />
      <br />
      <social-sign />
      </el-dialog>-->
      <remote-js src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-js>
      <div class="enterprise-info">
        企业名称：{{enterprisename}}
        备案号：
        <el-link :href="icplink" target="_blank" class="icp-link">
          {{enterpriseicp}}
          <i class="el-icon-view el-icon--right"></i>
        </el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import { authgeticp } from "@/api/orgin";
import LangSelect from "@/components/LangSelect";
import SocialSign from "./components/SocialSignin";

export default {
  name: "Login",
  components: {
    LangSelect,
    SocialSign,
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src },
        });
      },
      props: {
        src: { type: String, required: true },
      },
    },
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(); //已修改
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };
    return {
      enterprisename: "弥特盈泰（广州）科技有限公司",
      enterpriseicp: "粤ICP备13088542号-6",
      icplink: "http://beian.miit.gov.cn",
      title: process.env.VUE_APP_BASE_API_title,
      img: process.env.VUE_APP_BASE_API_img,
      account_type: [
        // {
        //   value: 0,
        //   label: '管理员'
        // },
        {
          value: 1,
          label: "管理员", //企业
        },
        {
          value: 2,
          label: "普通账号",
        },
        // {
        //   value: 3,
        //   label: '经销商'
        // },
      ],
      loginForm: {
        account_name: "",
        account_password: "",
        account_type: 2,
        ip: "",
      },
      loginRules: {
        account_name: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        account_password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      // 轮播图
      note: {
        backgroundImage:
          "url(" + require(process.env.VUE_APP_BASE_API_img) + ")",
        // backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        minHeight: "100vh",
      },
      imgList: [
        { id: 0, idView: require("./login-bg.e2134055.jpg") },
        { id: 1, name: "详情", idView: require("./login-bg.e2134055.jpg") },
        { id: 2, name: "推荐", idView: require("./login-bg.e2134055.jpg") },
      ],
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {

    this.getip();
    if (this.loginForm.username === "") {
      this.$refs.account_name.focus();
    } else if (this.loginForm.password === "") {
      this.$refs.account_password.focus();
    }
    this.geticps();
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    //获取ip
    getip() {
      setTimeout(() => {
        this.loginForm.ip = returnCitySN["cip"];
        console.log(this.loginForm.ip);
      }, 500);
    },
    //获取mac地址暂时不行
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= "a" && key <= "z") ||
          (!shiftKey && key >= "A" && key <= "Z")
        ) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.account_password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              this.$router.push({
                path: this.redirect || "/",
                query: this.otherQuery,
              });
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    geticps() {
      authgeticp({ enterprise_code: "dda49c8f984d49e4a1ac0eb205bc771b" }).then(
        (res) => {
          this.enterprisename = res.data.enterprise_name;
          this.enterpriseicp = res.data.enterprise_icp;
        }
      );
    },
  },
};
</script>

<style lang="scss">

$bg: #fff;
$light_gray: #283443;
$cursor: #283443;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      // background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        // -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
$bg: #fff;
$dark_gray: #fff;
$light_gray: #fff;
$img: "./login.png";
.login-form .el-button--primary {
  // 按钮颜色
  padding-left: 50px;
  background-color: #3fa137;
  border-color: #969696;
  font-size: 28px;
  letter-spacing: 50px;
  height: 50px;
}
.login-container {
  min-height: 100%;
  height: 100vh;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  position: relative;

  // background: url($img) no-repeat;
  // background-size: 100%;
  .login-form {
    left: 22%;
    top: 160px;
    position: relative;
    width: 500px;
    max-width: 100%;
    padding: 35px 35px 0;
    margin: 0 auto;
    overflow: hidden;
    opacity: 0.9;
    background-color: #45454514;
    border-radius: 10px;
    z-index: 1;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 10px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 32px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }

    .set-language {
      color: #fff;
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }
  .enterprise-info {
    position: absolute;
    bottom: 20px; // 距离图片底部的间距，可调整
    left: 50%;
    transform: translateX(-50%); // 水平居中
    color: #fff; // 文字白色，确保在图片上清晰显示（可根据图片底色调整）
    font-size: 14px;
    z-index: 0; // 层级低于登录表单，不遮挡表单
    text-align: center; // 内容居中对齐
    padding: 0 10px; // 左右内边距，避免超出视口

    .icp-link {
      color: #fff; // 备案链接文字颜色，与整体保持一致
      text-decoration: underline; // 下划线标识链接，提升体验
      &:hover {
        color: #e0e0e0; //  hover 效果，优化交互
      }
    }
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>
